import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'user-data-download',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./UserDataDownload').default
      callback(null, component)
    }, 'UserDataDownload')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/UserDataDownload/index.js